<script setup>
const emit = defineEmits(['deleteFromFavorite']);

const props = defineProps({
  goodsFavName: {
    type: String,
    required: true
  },
  operatingGoodsData: {
    type: Object,
    required: false,
    default: null
  }
});

</script>

<template>
  <div class="modal com_modal2 fade" id="deleteFromFavoriteConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1">以下の商品を「{{ props.goodsFavName }}」から削除しますか</h3>
          <p class="com_fs14 com_center1 com_mgb0">{{ props.operatingGoodsData?.goodsName || '商品名を取得中...' }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" @click="emit('deleteFromFavorite', props.operatingGoodsData?.janCode)" :disabled="!props.operatingGoodsData">はい</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">いいえ</button>
        </div>
      </div>
    </div>
  </div>
</template>
